const CANCEL = Symbol();

class Cancelled extends Error {
}

class CancelToken {
    constructor() {
        this.cancelled = false;
        this.callbacks = [];
    }

    throwIfCancelled() {
        if (this.cancelled) {
            throw new Cancelled();
        }
    }

    isCancelled() {
        return this.cancelled;
    }

    register(callback) {
        if (typeof callback !== 'function') {
            throw new Error(`attempt to register non-function callback`)
        }
        this.callbacks.push(callback);
    }

    [CANCEL]() {
        if (!this.cancelled) {
            this.cancelled = true;
            for (const cb of this.callbacks) {
                cb();
            }
        }
    }
}

class CancelTokenSource {
    constructor() {
        this.token = new CancelToken();
    }

    cancel() {
        this.token[CANCEL]();
    }
}

export default CancelTokenSource;
